import React, { useState, useEffect } from "react";
import { csvSafeRows } from "../../../utils/csvSafe";
import { useSelector, useDispatch } from "react-redux";
import { format, addDays } from "date-fns";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import {
  fetchApiData,
  fetchExportApiData,
} from "../../../redux/reducers/commonApiSlice";
import {
  export_expired_pt,
  exportTAEE,
  pt_members,
  pt_sale_stat_detail,
  pt_session,
  pt_trainer_details,
  pt_trial_3day,
} from "../../../data/ApiEndpoints";
import {
  convertStraight,
  convertThenFormat,
  convertTime,
  convertTimeHHMMSS,
  currentMonthCurrentDate,
  formatDateTime,
  formatDateTimezon,
} from "../../common-data/Converts";
import { BodyBuilder } from "../../../exports/Images";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { stringToColor } from "../../../data/Constants";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import moment from "moment";
import GTPTTrainerDetails from "./GTPTTrainerDetails";
import UserDetails from "../../incentive-system/user-details/UserDetails";
import OccupencyDetails from "../../components-react/OccupencyDetails";
import CommonStatCard from "./CommonStatCard";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";
import SelectExportables from "../../common-components/SelectExportables";
import { ptTrialExportable, taeeExportable } from "./users-info/calculations";
import { extractExpiredDaysAgo, isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";
import { fetchTodayPTRevenueDetailData } from "../../../redux/reducers/apiSlice";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const DATA_SORTING_ORDER = ["total", "payment_received", "payment_pending"];

const PTFlowStatCardDetails = ({
  userInfoData,
  clickedCard,
  prevAllFilters,
}) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);
  const { exportData, exportLoading } = useSelector((state) => state.common);
  const { ptRevenueTodayLoading, ptRevenueTodayError, ptRevenueToday } =
    useSelector((state) => state.api);

  const isLoading = loading || ptRevenueTodayLoading;

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const typeClicked = clickedCard === "total" ? "all" : clickedCard;

  const cardTypeInShort =
    clickedCard === "total" ||
    clickedCard === "active" ||
    clickedCard === "expiring" ||
    clickedCard === "expired"
      ? "taee"
      : clickedCard === "total_pt_trainer" ||
        clickedCard === "pt_trainer_with_pt" ||
        clickedCard === "pt_trainer_without_pt"
      ? "gt-pt-trainers"
      : clickedCard === "ongoing_session" ||
        clickedCard === "upcoming_session" ||
        clickedCard === "completed_session_today" ||
        clickedCard === "ongoing_session_expired"
      ? "pt-session"
      : clickedCard === "total_sales" ||
        clickedCard === "full_payment_received" ||
        clickedCard === "partial_payment_received" ||
        clickedCard === "partial_payment_pending" ||
        clickedCard === "carry_over_partial_received" ||
        clickedCard === "carry_over_partial_pending"
      ? "pt-revenue"
      : clickedCard;

  const isCurrentDate =
    clickedCard === "ongoing_session" ||
    clickedCard === "upcoming_session" ||
    clickedCard === "completed_session_today"
      ? currentMonthCurrentDate
      : null;

  const whatViewType =
    clickedCard === "carry_over_partial_received" ||
    clickedCard === "carry_over_partial_pending"
      ? "past_carry_over"
      : clickedCard === "total_sales" ||
        clickedCard === "full_payment_received" ||
        clickedCard === "partial_payment_received" ||
        clickedCard === "partial_payment_pending"
      ? "between_dates"
      : null;

  const isOngoingSession = clickedCard === "ongoing_session";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : prevAllFilters?.selectedGym
      ? prevAllFilters.selectedGym
      : "",
    selectedTrainer: "",
    selPTPlanStatus: "",
    regularSubsStatus: "",
    selectedSlotTime: "",
    selectedMonth: "",
    selectedStartDate:
      cardTypeInShort !== "pt-revenue" &&
      cardTypeInShort !== "taee" &&
      clickedCard !== "total_trial_subscription"
        ? isCurrentDate
          ? isCurrentDate
          : prevAllFilters?.startDate
          ? prevAllFilters.startDate
          : ""
        : "",
    selectedEndDate:
      !cardTypeInShort === "pt-revenue" &&
      cardTypeInShort !== "taee" &&
      clickedCard !== "total_trial_subscription"
        ? isCurrentDate
          ? isCurrentDate
          : prevAllFilters?.endDate
          ? prevAllFilters.endDate
          : ""
        : "",
    subsAddDateFrom:
      cardTypeInShort === "pt-revenue" ||
      cardTypeInShort === "taee" ||
      clickedCard === "total_trial_subscription"
        ? isCurrentDate
          ? isCurrentDate
          : prevAllFilters?.startDate
          ? prevAllFilters.startDate
          : ""
        : "",
    subsAddDateTo:
      cardTypeInShort === "pt-revenue" ||
      cardTypeInShort === "taee" ||
      clickedCard === "total_trial_subscription"
        ? isCurrentDate
          ? isCurrentDate
          : prevAllFilters?.endDate
          ? prevAllFilters.endDate
          : ""
        : "",
    regSubsAddDateFrom: "",
    regSubsAddDateTo: "",
    memberLastCheckinDateFrom: "",
    memberLastCheckinDateTo: "",
    expiredDateFrom: "",
    expiredDateTo: "",

    searchString: "",
    isToggledValue: false,
    selectedConvertedStatus: "",
    selExpiredDaysAgo: [],
    selectedPTRevenueViewType: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    type: cardTypeInShort === "taee" ? typeClicked : "",
    filter_type: cardTypeInShort === "pt-session" ? typeClicked : "",
    trainer_type: cardTypeInShort === "gt-pt-trainers" ? typeClicked : "",
    view_type:
      clickedCard === "total_sales_today"
        ? allFilters.selectedPTRevenueViewType?.value || ""
        : cardTypeInShort === "pt-revenue" && whatViewType
        ? whatViewType
        : "",
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    subscription_status: allFilters.selPTPlanStatus?.value || "",
    regular_subscription_status: allFilters.regularSubsStatus?.value || "",
    slot_time: allFilters.selectedSlotTime?.value || "",
    month: allFilters.selectedMonth?.value || "",
    start_date:
      cardTypeInShort === "pt-revenue"
        ? allFilters.subsAddDateFrom
        : cardTypeInShort !== "taee" &&
          clickedCard !== "total_trial_subscription"
        ? allFilters.selectedStartDate
        : "",
    end_date:
      cardTypeInShort === "pt-revenue"
        ? allFilters.subsAddDateTo
        : cardTypeInShort !== "taee" &&
          clickedCard !== "total_trial_subscription"
        ? allFilters.selectedEndDate
        : "",
    date_from:
      cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
        ? allFilters.subsAddDateFrom
        : "",
    date_to:
      cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
        ? allFilters.subsAddDateTo
        : "",
    session_date: allFilters.selectedStartDate || "",
    regular_start_date:
      cardTypeInShort === "pt-revenue" ? allFilters.regSubsAddDateFrom : "",
    regular_end_date:
      cardTypeInShort === "pt-revenue" ? allFilters.regSubsAddDateTo : "",
    member_last_checkin_date_from:
      cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
        ? allFilters.memberLastCheckinDateFrom
        : "",
    member_last_checkin_date_to:
      cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
        ? allFilters.memberLastCheckinDateTo
        : "",
    expired_from: clickedCard === "expired" ? allFilters.expiredDateFrom : "",
    expired_to: clickedCard === "expired" ? allFilters.expiredDateTo : "",

    remove_duplicacy:
      clickedCard === "expired" ? (allFilters.isToggledValue ? 1 : 0) : "",
    converted:
      clickedCard === "total_trial_subscription"
        ? allFilters.selectedConvertedStatus?.value || ""
        : "",
    expired_days_ago: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniPTDatas = {
    pagination: [],
    allDetailData: [],
    allFullData: {},
    allPartialData: {},
    allPartialPendingData: {},
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    image: "",
    partialDetails: [],
    isModOpen1: false,
    modName1: "",
    rowData1: "",
    shiftDetailsQP: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [csvData, setCsvData] = useState();

  const onClickReset = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setIsPage(0);
  };

  const onCloseModal = (name) => {
    if (name === "mod1") {
      setModValues((prevs) => ({
        ...prevs,
        isModOpen1: false,
        modName1: "",
        rowData1: "",
      }));
    } else {
      setModValues(iniModValues);
    }
  };

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    const shiftDetailsQP = `gym_id=${row?.gym_id || ""}&trainer_id=${
      row?.trainer_id || ""
    }`;

    const cardName = name;

    setModValues((prevs) => ({
      ...prevs,
      isModOpen1: true,
      modName1: cardName,
      rowData1: row || "",
      shiftDetailsQP: shiftDetailsQP || "",
    }));
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  const handleTabSelect = () => {
    setIsPage(0);
  };

  function getDetails(filters, endpoint) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getPTRevenueTodayDetails(filters) {
    const {
      type,
      filter_type,
      trainer_type,
      slot_time,
      month,
      start_date,
      end_date,
      date_from,
      date_to,
      session_date,
      regular_start_date,
      regular_end_date,
      member_last_checkin_date_from,
      member_last_checkin_date_to,
      expired_from,
      expired_to,
      remove_duplicacy,
      converted,
      expired_days_ago,
      subscription_status,
      regular_subscription_status,
      ...rest
    } = filters;

    dispatch(
      fetchTodayPTRevenueDetailData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getExportedData(filters) {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint:
          clickedCard === "total_trial_subscription"
            ? export_expired_pt
            : exportTAEE,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExport = (filters) => {
    if (filters.is_export) {
      getExportedData(filters);
    } else {
      toast.error("IS Export Not Found!");
    }
  };

  const sortedCards = (objData) => {
    return (
      objData &&
      Object?.entries(objData)
        ?.sort(([keyA], [keyB]) => {
          const indexA = DATA_SORTING_ORDER.indexOf(keyA);
          const indexB = DATA_SORTING_ORDER.indexOf(keyB);

          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        })
        ?.map(([key, value], index) => (
          <React.Fragment key={index}>
            {key !== "total" && (
              <CommonStatCard
                tagName={key}
                cardLabel={key ? key.replace(/_/g, " ") : "NA"}
                value={`₹${convertThenFormat(value || 0)}`}
              />
            )}
          </React.Fragment>
        ))
    );
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : prevAllFilters?.selectedGym
        ? prevAllFilters.selectedGym
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    if (cardTypeInShort === "taee" && filters.type) {
      const {
        filter_type,
        session_date,
        trainer_type,
        start_date,
        end_date,
        ...rest
      } = filters;

      getDetails(rest, pt_members);
    } else if (cardTypeInShort === "pt-session" && filters.filter_type) {
      const {
        type,
        start_date,
        end_date,
        date_from,
        date_to,
        trainer_type,
        ...rest
      } = filters;
      const { session_date, ...restRest } = rest || {};

      const sendableFilters =
        clickedCard === "ongoing_session_expired" ? restRest : rest;

      getDetails(sendableFilters, pt_session);
    } else if (cardTypeInShort === "gt-pt-trainers" && filters.trainer_type) {
      const { type, filter_type, session_date, date_from, date_to, ...rest } =
        filters;

      getDetails(rest, pt_trainer_details);
    } else if (cardTypeInShort === "pt-revenue") {
      const { type, filter_type, session_date, date_from, date_to, ...rest } =
        filters;

      getDetails(rest, pt_sale_stat_detail);
    } else if (clickedCard === "total_trial_subscription") {
      const { type, filter_type, session_date, start_date, end_date, ...rest } =
        filters;

      getDetails(rest, pt_trial_3day);
    } else if (clickedCard === "total_sales_today") {
      getPTRevenueTodayDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (clickedCard !== "total_sales_today") {
      if (data?.status && !loading && !error) {
        if (cardTypeInShort === "pt-revenue") {
          const { full_data, partial_data, partial_pending_data } = data || {};

          setAllDatas((prevs) => ({
            ...prevs,
            allFullData: full_data || {},
            allPartialData: partial_data || {},
            allPartialPendingData: partial_pending_data || {},
            allDetailData: [],
            pagination: [],
          }));
        } else if (data?.data?.length > 0) {
          setAllDatas((prevs) => ({
            ...prevs,
            allDetailData: data.data,
            pagination: data?.pagination?.length > 0 ? data.pagination : [],
            allFullData: {},
            allPartialData: {},
            allPartialPendingData: {},
          }));
        } else {
          setAllDatas(iniPTDatas);
        }
      } else {
        setAllDatas(iniPTDatas);
      }
    }
  }, [data, cardTypeInShort, loading, error]);

  useEffect(() => {
    if (clickedCard === "total_sales_today") {
      if (
        !ptRevenueTodayLoading &&
        !ptRevenueTodayError &&
        ptRevenueToday?.status &&
        ptRevenueToday?.data?.length > 0
      ) {
        setAllDatas((prevs) => ({
          ...prevs,
          allDetailData: ptRevenueToday.data,
          pagination:
            ptRevenueToday?.pagination?.length > 0
              ? ptRevenueToday.pagination
              : [],
        }));
      } else {
        setAllDatas(iniPTDatas);
      }
    }
  }, [ptRevenueTodayLoading, ptRevenueTodayError, ptRevenueToday]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: prevAllFilters?.selectedGym || "",
      selectedStartDate:
        cardTypeInShort !== "pt-revenue" &&
        cardTypeInShort !== "taee" &&
        clickedCard !== "total_trial_subscription"
          ? isCurrentDate
            ? isCurrentDate
            : prevAllFilters?.startDate
            ? prevAllFilters.startDate
            : ""
          : "",
      selectedEndDate:
        cardTypeInShort !== "pt-revenue" &&
        cardTypeInShort !== "taee" &&
        clickedCard !== "total_trial_subscription"
          ? isCurrentDate
            ? isCurrentDate
            : prevAllFilters?.endDate
            ? prevAllFilters.endDate
            : ""
          : "",
      subsAddDateFrom:
        cardTypeInShort === "pt-revenue" ||
        cardTypeInShort === "taee" ||
        clickedCard === "total_trial_subscription"
          ? isCurrentDate
            ? isCurrentDate
            : prevAllFilters?.startDate
            ? prevAllFilters.startDate
            : ""
          : "",
      subsAddDateTo:
        cardTypeInShort === "pt-revenue" ||
        cardTypeInShort === "taee" ||
        clickedCard === "total_trial_subscription"
          ? isCurrentDate
            ? isCurrentDate
            : prevAllFilters?.endDate
            ? prevAllFilters.endDate
            : ""
          : "",
    }));
  }, [
    cardTypeInShort,
    prevAllFilters?.selectedGym,
    isCurrentDate,
    prevAllFilters?.startDate,
    prevAllFilters.endDate,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      type: cardTypeInShort === "taee" ? typeClicked : "",
      filter_type: cardTypeInShort === "pt-session" ? typeClicked : "",
      trainer_type: cardTypeInShort === "gt-pt-trainers" ? typeClicked : "",
      view_type:
        cardTypeInShort === "pt-revenue" && whatViewType ? whatViewType : "",
    }));
  }, [typeClicked, isPage, pageLimit, whatViewType]);

  useEffect(() => {
    const { days_ago } = extractExpiredDaysAgo(allFilters.selExpiredDaysAgo);

    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      subscription_status: allFilters.selPTPlanStatus?.value || "",
      regular_subscription_status: allFilters.regularSubsStatus?.value || "",
      slot_time: allFilters.selectedSlotTime?.value || "",
      month: allFilters.selectedMonth?.value || "",
      start_date:
        cardTypeInShort === "pt-revenue"
          ? allFilters.subsAddDateFrom
          : cardTypeInShort !== "taee" &&
            clickedCard !== "total_trial_subscription"
          ? allFilters.selectedStartDate
          : "",
      end_date:
        cardTypeInShort === "pt-revenue"
          ? allFilters.subsAddDateTo
          : cardTypeInShort !== "taee" &&
            clickedCard !== "total_trial_subscription"
          ? allFilters.selectedEndDate
          : "",
      date_from:
        cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
          ? allFilters.subsAddDateFrom
          : "",
      date_to:
        cardTypeInShort === "taee" || clickedCard === "total_trial_subscription"
          ? allFilters.subsAddDateTo
          : "",
      session_date: allFilters.selectedStartDate || "",
      regular_start_date:
        cardTypeInShort === "pt-revenue" ? allFilters.regSubsAddDateFrom : "",
      regular_end_date:
        cardTypeInShort === "pt-revenue" ? allFilters.regSubsAddDateTo : "",
      member_last_checkin_date_from:
        cardTypeInShort === "taee" ? allFilters.memberLastCheckinDateFrom : "",
      member_last_checkin_date_to:
        cardTypeInShort === "taee" ? allFilters.memberLastCheckinDateTo : "",
      expired_from: clickedCard === "expired" ? allFilters.expiredDateFrom : "",
      expired_to: clickedCard === "expired" ? allFilters.expiredDateTo : "",
      remove_duplicacy:
        clickedCard === "expired" ? (allFilters.isToggledValue ? 1 : 0) : "",
      converted:
        clickedCard === "total_trial_subscription"
          ? allFilters.selectedConvertedStatus?.value || ""
          : "",
      expired_days_ago: days_ago || "",
      view_type:
        clickedCard === "total_sales_today"
          ? allFilters.selectedPTRevenueViewType?.value || ""
          : cardTypeInShort === "pt-revenue" && whatViewType
          ? whatViewType
          : "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selPTPlanStatus,
    allFilters.regularSubsStatus,
    allFilters.selectedSlotTime,
    allFilters.selectedMonth,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    cardTypeInShort,
    allFilters.subsAddDateFrom,
    allFilters.subsAddDateTo,
    allFilters.regSubsAddDateFrom,
    allFilters.regSubsAddDateTo,
    allFilters.memberLastCheckinDateFrom,
    allFilters.memberLastCheckinDateTo,
    allFilters.expiredDateFrom,
    allFilters.expiredDateTo,
    allFilters.isToggledValue,
    allFilters.selectedConvertedStatus,
    allFilters.selExpiredDaysAgo,
    clickedCard,
    allFilters.selectedPTRevenueViewType,
    whatViewType,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(csvSafeRows(exportData));
    } else {
      setCsvData();
    }
  }, [exportData]);

  const tbColumn = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.member_profile ? (
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "N/A"}
              className="image"
              onClick={() =>
                row?.member_profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.member_profile,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.member_name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.member_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.member_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span
            className="tb-data text-start link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "member_info",
                rowData1: row,
              }))
            }
          >
            {row?.member_name || "NA"}
            <br />
            {(row?.member_mobile || row?.member_email) && (
              <small className="lowercase">
                {row?.member_mobile || ""}
                <br />
                {row?.member_email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer column minWidth150"
          onClick={(e) => onClickValues(e, row, "shift_details")}
        >
          <p className="info bold link underline">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹{convertThenFormat(row?.price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          {row?.is_partial === "true"
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_online
              : row?.total_online || 0
          )}
        </span>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_cash
              : row?.total_cash || 0
          )}
        </span>
      ),
    },
    {
      dataField: "session_status",
      text: "session status(No of Days)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Purchase date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
        </span>
      ),
    },
    cardTypeInShort === "taee" && {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "member_checkin_details",
                userId: row?.user_id,
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }));
            }}
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "PT Plan Duration",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100 underline tb-col">
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth150"
          style={{
            background:
              row?.subscription_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.subscription_status || "NA"}
          {clickedCard === "expired" && (
            <small>
              <br />({row?.subscription_expiry_days || ""})
            </small>
          )}
        </span>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.regular_subscription_status === "active"
                ? "#0A701B"
                : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.regular_subscription_status || "NA"}
        </span>
      ),
    },
  ];

  const sessionTbColumn = [
    {
      dataField: "user_name",
      text: "Member",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.user_profile ? (
            <img
              src={row?.user_profile || BodyBuilder}
              alt={row?.user_name || "N/A"}
              className="image"
              onClick={() =>
                row?.user_profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.user_profile,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.user_name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.user_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.user_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span
            className="tb-data text-start link"
            onClick={(e) => onClickValues(e, row, "member_info")}
          >
            {row?.user_name || "NA"}
            <br />
            {(row?.user_mobile || row?.user_email) && (
              <small className="lowercase">
                {row?.user_mobile || ""}
                <br />
                {row?.user_email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (cell, row) => (
        <span
          className="tb-data link"
          onClick={(e) => onClickValues(e, row, "shift_details")}
        >
          {row?.trainer_name || "N/A"}
        </span>
      ),
    },
    {
      dataField: "date",
      text: isOngoingSession
        ? "Current Session date & Time"
        : "Last Session date & Time",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.last_session_datetime
            ? formatDateTime(row.last_session_datetime)
            : "-"}
        </span>
      ),
    },
    {
      dataField: "last_session_status",
      text: isOngoingSession
        ? "Current Session Status"
        : "Last  Session  Status",
      formatter: (cell, row) => {
        const lastSessionStatus = row?.last_session_status;

        return (
          <>
            {lastSessionStatus === "verified" ? (
              <span className="tb-data icon">
                <CheckCircleIcon />
              </span>
            ) : (
              <span
                className="tb-data"
                style={{
                  background:
                    lastSessionStatus === "pending" ? "#FCCD2A" : "#F13434",
                  color: "#fff",
                  borderRadius: "8px",
                  padding: "5px 10px",
                }}
              >
                {lastSessionStatus || "NA"}
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: isOngoingSession ? "Member Checkin" : "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "member_checkin_details",
                userId: row?.user_id,
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }));
            }}
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />({row?.checkin_time ? convertTime(row.checkin_time) : ""})
            <br />
            <small>{row?.last_checkin_days_ago?.replace(/_/g, " ")}</small>
          </span>
        );
      },
    },
    {
      dataField: "ongoing_session_no",
      text: "session No.",
      formatter: (cell, row) => (
        <span
          className="tb-data"
          style={{
            background: "#09BA09",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.ongoing_session_no || "-"}
        </span>
      ),
    },
    {
      dataField: "pt_consumption",
      text: "PT session Consumption",
      formatter: (cell, row) => (
        <span
          className="tb-data"
          style={{
            background: "#FFEDC0",
            color: "#171717",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.pt_consumption || "-"}
        </span>
      ),
    },
    {
      dataField: "slot_start_time",
      text: "PT Session time",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth150"
          style={{
            background: "#ECECEC",
            color: "#0C0B0B",
            borderRadius: "4px",
            padding: "5px 0",
            fontSize: "13px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            columnGap: "5px",
          }}
        >
          {row?.slot_start_time ? convertTime(row.slot_start_time) : "-"}
          <small>-</small>
          {row?.slot_end_time ? convertTime(row.slot_end_time) : "-"}
        </span>
      ),
    },
    {
      dataField: "pt_start_date",
      text: "PT Plan Duration",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100 underline">
          {row?.pt_start_date ? formatDateTimezon(row.pt_start_date) : "-"}
          <br />
          {row?.pt_end_date ? formatDateTimezon(row.pt_end_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "membership_start_date",
      text: "Membership duration",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100 underline">
          {row?.membership_start_date
            ? formatDateTimezon(row.membership_start_date)
            : "-"}
          <br />
          {row?.membership_end_date
            ? formatDateTimezon(row.membership_end_date)
            : "-"}
        </span>
      ),
    },
    {
      dataField: "pt_plan_status",
      text: "PT Plan status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.pt_plan_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.pt_plan_status || "NA"}
        </span>
      ),
    },
    {
      dataField: "membership_status",
      text: "Membership status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.membership_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.membership_status || "NA"}
        </span>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  const tbColumnsTrainers = [
    {
      dataField: "trainer_name",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Trainer</span>
        </div>
      ),
      formatter: (cell, row, rowIndex) => (
        <div
          className="emeberDetailsRowContainer"
          style={{ textAlign: "center" }}
        >
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.trainer_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={() =>
              row?.trainer_profile &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "image_view",
                image: row?.trainer_profile,
              }))
            }
          />
          <span
            className="tb-data link minWidth150"
            style={{
              textAlign: "start",
              textDecoration: "underline",
            }}
            onClick={(e) => onClickValues(e, row, "shift_details")}
          >
            {row?.trainer_name || "NA"}
            {row?.trainer_category === "Personal Trainer" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-patch-check-fill"
                viewBox="0 0 16 16"
                style={{
                  marginLeft: "5px",
                  color: "#379C00",
                }}
              >
                <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
              </svg>
            ) : null}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">gym name</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "joining_date",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Joining Date</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "salary",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Salary</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.salary || 0)}
          </span>
        );
      },
    },
    {
      dataField: "shift_timing",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Trainer Shift</span>
        </div>
      ),
      formatter: (cell, row) => {
        const shiftTimings = row?.shift_timing?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <span className="tb-data minWidth150 underline">
            {shiftTiming || ""}
          </span>
        );
      },
    },
    {
      dataField: "pt_this_month_added_amount",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">PT Amount</span>
          <span className="tb-head">Partial/full</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <b>₹{convertThenFormat(row?.pt_this_month_added_amount || 0)}</b>
            <br />
            (₹{convertThenFormat(
              row?.pt_this_month_added_amount_partial || 0
            )}{" "}
            / {convertThenFormat(row?.pt_this_month_added_amount_full || 0)})
          </span>
        );
      },
    },
    {
      dataField: "total_active_pt",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Active PT Members</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data underline bold"
            style={{
              color: "#079107",
              cursor: "pointer",
            }}
            onClick={() =>
              row?.total_active_pt &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "trainer_active_PT_member",
                rowData1: row,
              }))
            }
          >
            {row?.total_active_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "pt_this_month_added",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">PT Members added this month</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data underline bold"
            style={{
              color: "#0A4CCC",
              cursor: "pointer",
            }}
            onClick={() =>
              row?.pt_this_month_added &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "trainer_PT_this_month",
                rowData1: row,
              }))
            }
          >
            {row?.pt_this_month_added || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expiring_pt",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Expiring PT Members</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data underline bold"
            style={{
              color: "#CC440A",
              cursor: "pointer",
            }}
            onClick={() =>
              row?.total_expiring_pt &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "trainer_expiring_PT",
                rowData1: row,
              }))
            }
          >
            {row?.total_expiring_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expired_pt",
      text: (
        <div className="multi-stack-tb-heading">
          <span className="tb-head bold">Expired PT Members</span>
        </div>
      ),
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data underline bold"
            style={{
              color: "#BA0934",
              cursor: "pointer",
            }}
            onClick={() =>
              row?.total_expired_pt &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "trainer_expired_PT",
                rowData1: row,
              }))
            }
          >
            {row?.total_expired_pt || 0}
          </span>
        );
      },
    },
  ];

  const tbColumnRevenue = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.member_profile ? (
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "N/A"}
              className="image"
              onClick={() =>
                row?.member_profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.member_profile,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.member_name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.member_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.member_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span
            className="tb-data text-start link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "member_info",
                rowData1: row,
              }))
            }
          >
            {row?.member_name || "NA"}
            <br />
            {(row?.member_mobile || row?.member_email) && (
              <small className="lowercase">
                {row?.member_mobile || ""}
                <br />
                {row?.member_email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer column minWidth150"
          onClick={(e) => onClickValues(e, row, "shift_details")}
        >
          <p className="info bold link">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹{convertThenFormat(row?.price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          {row?.is_partial === "true"
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_online
              : row?.total_online || 0
          )}
        </span>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_cash
              : row?.total_cash || 0
          )}
        </span>
      ),
    },
    {
      dataField: "session_status",
      text: "session status(No of Days)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    // {
    //   dataField: "date_added",
    //   text: "PT Purchase date",
    //   formatter: (cell, row) => (
    //     <span className="tb-data minWidth100">
    //       {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
    //     </span>
    //   ),
    // },
    {
      dataField: "start_date",
      text: "PT Plan",
      formatter: (cell, row) => (
        <span className="tb-data minWidth200">
          <small className="underline" style={{ color: "gray" }}>
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </small>
          <br />

          <small className="underline">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
            <b> - </b>
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </small>
          <br />

          <small
            style={{
              display: "block",
              marginTop: "3px",
              background:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              color: "#fff",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </small>
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "Regular Plan",
      formatter: (cell, row) => (
        <span className="tb-data minWidth200">
          <small className="underline" style={{ color: "gray" }}>
            {row?.regular_date_added
              ? formatDateTimezon(row.regular_date_added)
              : "-"}
          </small>
          <br />

          <small className="underline">
            {row?.regular_start_date
              ? formatDateTimezon(row.regular_start_date)
              : "-"}
            <b> - </b>
            {row?.regular_expire_date
              ? formatDateTimezon(row.regular_expire_date)
              : "-"}
          </small>
          <br />

          <small
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              color: "#fff",
              borderRadius: "8px",
              padding: "5px 10px",
              textDecoration: "none",
              display: "block",
              marginTop: "3px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </small>
        </span>
      ),
    },
    // {
    //   dataField: "subscription_status",
    //   text: "PT Subscription status",
    //   formatter: (cell, row) => (
    //     <span
    //       className="tb-data minWidth100"
    //       style={{
    //         background:
    //           row?.subscription_status === "active" ? "#0A701B" : "#F13434",
    //         color: "#fff",
    //         borderRadius: "8px",
    //         padding: "5px 10px",
    //       }}
    //     >
    //       {row?.subscription_status || "NA"}
    //     </span>
    //   ),
    // },
    // {
    //   dataField: "regular_subscription_status",
    //   text: "Regular Subscription status",
    //   formatter: (cell, row) => (
    //     <span
    //       className="tb-data minWidth100"
    //       style={{
    //         background:
    //           row?.regular_subscription_status === "active"
    //             ? "#0A701B"
    //             : "#F13434",
    //         color: "#fff",
    //         borderRadius: "8px",
    //         padding: "5px 10px",
    //       }}
    //     >
    //       {row?.regular_subscription_status || "NA"}
    //     </span>
    //   ),
    // },
  ];

  const tbColumnPTTrial = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.member_profile ? (
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "N/A"}
              className="image"
              onClick={() =>
                row?.member_profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.member_profile,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.member_name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.member_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.member_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span
            className="tb-data text-start link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen1: true,
                modName1: "member_info",
                rowData1: row,
              }))
            }
          >
            {row?.member_name || "NA"}
            <br />
            {(row?.member_mobile || row?.member_email) && (
              <small className="lowercase">
                {row?.member_mobile || ""}
                <br />
                {row?.member_email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "converted",
      text: "conversion",
      formatter: (cell, row) => {
        return (
          <span className="tb-data icon tb-col minWidth200">
            {row?.converted ? <CheckCircleIcon /> : <CrossCircleIcon />}

            {row?.converted ? (
              <>
                <small className="gray text-xs underline">
                  {row?.converted_date_added
                    ? formatDateTimezon(row.converted_date_added)
                    : "-"}
                </small>
                <small className="bold">
                  ₹{convertThenFormat(row?.converted_price || 0)}(
                  {row?.converted_n_session || ""} sessions)
                </small>
                <small className="underline">
                  {row?.converted_start_date
                    ? formatDateTimezon(row.converted_start_date)
                    : "-"}{" "}
                  -{" "}
                  {row?.converted_expire_date
                    ? formatDateTimezon(row.converted_expire_date)
                    : "-"}
                </small>
              </>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer column minWidth150"
          onClick={(e) => onClickValues(e, row, "shift_details")}
        >
          <p className="info bold link underline">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status(No of Days)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "last_session",
      text: "Last Session Date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.last_session ? formatDateTime(row.last_session) : "-"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Purchase date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "PT Plan Duration",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100 underline">
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "member_checkin_details",
                userId: row?.user_id,
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }));
            }}
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.subscription_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.subscription_status || "NA"}
        </span>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.regular_subscription_status === "active"
                ? "#0A701B"
                : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.regular_subscription_status || "NA"}
        </span>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          {
            <ModalHeadAndClose
              title={modValues.modName?.replace(/_/g, " ")}
              onClose={onCloseModal}
            />
          }

          {modValues.modName === "image_view" ? (
            <div className="discussionModalMessage">
              <img
                src={modValues.image}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.modName === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : modValues.modName === "member_checkin_details" ? (
            <MemberCheckinLogs
              clickValues={modValues}
              sendableStatsQPs={modValues.sendableStatsQPs}
              from="pt-flow"
            />
          ) : modValues.modName === "export_data" ? (
            <SelectExportables
              name={"pt-flow-taee"}
              exportableData={
                clickedCard === "total_trial_subscription"
                  ? ptTrialExportable
                  : taeeExportable
              }
              filters={filters}
              callFunction={onClickExport}
              isLoadingCSV={exportLoading}
              csvData={csvData}
              setCsvData={setCsvData}
            />
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModOpen1}
        onRequestClose={() => onCloseModal("mod1")}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={modValues.modName1?.replace(/_/g, " ")}
            onClose={() => onCloseModal("mod1")}
          />

          {modValues.modName1 === "trainer_active_PT_member" ||
          modValues.modName1 === "trainer_expiring_PT" ||
          modValues.modName1 === "trainer_PT_this_month" ||
          modValues.modName1 === "trainer_expired_PT" ? (
            <GTPTTrainerDetails
              prevModValues={modValues}
              userInfoData={userInfoData}
              prevAllFilters={allFilters}
            />
          ) : modValues.modName1 === "member_info" ? (
            <UserDetails
              row={modValues?.rowData1}
              userInfoData={userInfoData}
            />
          ) : modValues.modName1 === "shift_details" ? (
            <OccupencyDetails
              queryParametersForAll={modValues.shiftDetailsQP}
            />
          ) : null}
        </div>
      </Modal>

      <CommonFilterStructure
        from={"pt-flow"}
        decryptedText={userInfoData}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        clickedCard={
          clickedCard === "completed_session_today"
            ? clickedCard
            : cardTypeInShort
        }
        clickedCardAsItIs={clickedCard}
        handleDateRangeChange={handleDateRangeChange}
        rangeState={rangeState}
        clearDateRanger={clearDateRanger}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={isLoading}
        onClickExportBtn={() => {
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: "export_data",
          }));
        }}
      />

      {clickedCard === "total_sales" ? (
        <div className="cupon-requests-tabs mt30">
          <Tabs onSelect={handleTabSelect}>
            <TabList>
              <Tab>Full</Tab>
              <Tab>Partial</Tab>
            </TabList>

            <TabPanel>
              <div className="cards-container cards-grid-container grid-5 pt-flow-new">
                {sortedCards(allDatas.allFullData?.stats)}
              </div>

              <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      allDatas.allFullData?.data?.length > 0
                        ? allDatas.allFullData.data
                        : []
                    }
                    tableColumns={tbColumnRevenue}
                    tablePagination={
                      allDatas.allFullData?.pagination?.length > 0
                        ? allDatas.allFullData.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    isFirstColSticky={true}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                )}
              </div>
            </TabPanel>
            <TabPanel>
              <div className="cards-container cards-grid-container grid-5 pt-flow-new">
                {sortedCards(allDatas.allPartialData?.stats)}
              </div>

              <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={
                      allDatas.allPartialData?.data?.length > 0
                        ? allDatas.allPartialData.data
                        : []
                    }
                    tableColumns={tbColumnRevenue}
                    tablePagination={
                      allDatas.allPartialData?.pagination?.length > 0
                        ? allDatas.allPartialData.pagination
                        : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                    isFirstColSticky={true}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                  />
                )}
              </div>
            </TabPanel>
          </Tabs>
        </div>
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          {cardTypeInShort === "pt-revenue" && (
            <div className="cards-container cards-grid-container grid-5 pt-flow-new">
              {sortedCards(
                clickedCard === "full_payment_received"
                  ? allDatas.allFullData?.stats
                  : clickedCard === "partial_payment_pending" ||
                    clickedCard === "carry_over_partial_pending"
                  ? allDatas.allPartialPendingData?.stats
                  : allDatas.allPartialData?.stats
              )}
            </div>
          )}

          {isLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableData={
                clickedCard === "full_payment_received"
                  ? allDatas.allFullData?.data?.length > 0
                    ? allDatas.allFullData.data
                    : []
                  : clickedCard === "partial_payment_pending" ||
                    clickedCard === "carry_over_partial_pending"
                  ? allDatas.allPartialPendingData?.data?.length > 0
                    ? allDatas.allPartialPendingData.data
                    : []
                  : cardTypeInShort === "pt-revenue"
                  ? allDatas.allPartialData?.data?.length > 0
                    ? allDatas.allPartialData.data
                    : []
                  : allDatas.allDetailData
              }
              tableColumns={
                cardTypeInShort === "pt-session"
                  ? sessionTbColumn
                  : cardTypeInShort === "gt-pt-trainers"
                  ? tbColumnsTrainers
                  : cardTypeInShort === "pt-revenue"
                  ? tbColumnRevenue
                  : cardTypeInShort === "total_trial_subscription"
                  ? tbColumnPTTrial
                  : tbColumn
              }
              tablePagination={
                clickedCard === "full_payment_received"
                  ? allDatas.allFullData?.pagination?.length > 0
                    ? allDatas.allFullData.pagination
                    : []
                  : clickedCard === "partial_payment_pending" ||
                    clickedCard === "carry_over_partial_pending"
                  ? allDatas.allPartialPendingData?.pagination?.length > 0
                    ? allDatas.allPartialPendingData.pagination
                    : []
                  : cardTypeInShort === "pt-revenue"
                  ? allDatas.allPartialData?.pagination?.length > 0
                    ? allDatas.allPartialData.pagination
                    : []
                  : allDatas.pagination
              }
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              isFirstColSticky={true}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </div>
      )}
    </>
  );
};

export default PTFlowStatCardDetails;
